// extracted by mini-css-extract-plugin
module.exports = {"container":"Gafam_container__1Ly3Q","Tendances":"Gafam_Tendances__wZoub","TendanceText":"Gafam_TendanceText__2pqaE","TendancesWrapper":"Gafam_TendancesWrapper__3Kw0P"};